export const agrofag = {
    state: {
        status: 'idle',
        agrofag: null
    },
    mutations: {
        SET_AGROFAG_STATUS(state, status) {
            state.status = status
        },
        SET_AGROFAG(state, agrofag) {
            state.agrofag = agrofag
        }
    },
    actions: {
        fetchAgrofag({ state, commit }, payload) {
            commit('SET_AGROFAG', null)
            commit('SET_AGROFAG_STATUS', 'loading')
            return this.$api.get(`api/agrofags/${payload}.json`).then(response => {
                commit('SET_AGROFAG', response.data.data)
                commit('SET_AGROFAG_STATUS', 'idle')
            }).catch(error => {
                commit('SET_AGROFAG_STATUS', 'error')
                return Promise.reject(error)
            })
        }
    },
    getters: {
        agrofagStatus: (state) => {
            return state.status
        },
        agrofag: (state) => {
            if(state.agrofag) {
                return state.agrofag
            }
        }
    }
}
